import { SDK_LOG_LEVELS } from "@components/Conference/config/constants";

const urlParams = new URLSearchParams(window.location.search);
const queryLogLevel = urlParams.get("logLevel") || "off";
const logLevel = SDK_LOG_LEVELS[queryLogLevel] || SDK_LOG_LEVELS.off;

const postLogConfig = {
    name: "SDK_LOGS",
    batchSize: 85,
    intervalMs: 2000,
    url: "/logs",
    logLevel
};

const config = {
    logLevel,
    postLogConfig
};

export default config;
